// Exact copy from the "Nhắc nhở sau tiết học" export; ticking OTHER reveals a free-text input.
export const REMINDER_OTHER = 'Khác';

export const REMINDER_PRESETS = [
  'Các em soạn bài mới',
  'Chuẩn bị nội dung cho bài học trong buổi sau',
  'Buổi sau các em chuẩn bị kiểm tra 45 phút',
  'Các em chuẩn bị dụng cụ học tập',
  REMINDER_OTHER,
];

export interface ReminderHomeworkSuggestion {
  id: string;
  name: string;
  questionCount?: number;
}
